export { default } from "./Cover.js";
